import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Button } from "../../../components/buttons/button";
import { InfoCard } from "../../../components/cards/infoCard";
import { PayoutForm } from "../../../components/modal/app_modals/addPayoutAccountModal";
import { ConfirmationModal } from "../../../components/modal/app_modals/confirmationModal";
import { BgWrapper } from "../../../components/wrapper/bgWrapper";
import { useModalControl } from "../../../customeHooks/useModalControl";
import { useUpdateEventStatusMutation } from "../../../redux/features/event/event.api";

export const AddPayoutPage = () => {
  const navigate = useNavigate();

  const { id } = useParams();

  const [updateEventStatus, { isLoading: updatingEventStatus }] =
    useUpdateEventStatusMutation();

  const { modal, modalOpen, handleModalClose, handleModalOpen } =
    useModalControl();

  return (
    <div className="flex w-full justify-center">
      <div className="mx-auto flex w-full max-w-[500px] flex-col gap-3">
        <BgWrapper className="flex w-full flex-col items-center justify-center gap-4 !py-10">
          <div className="mx-auto w-full max-w-[320px] text-center">
            <p className="text-32 max-w-[300px] font-fraunces font-medium">
              Add Your <br />
              Payout Account
            </p>
            <p className="mt-2 max-w-[320px] text-grey-600">
              You’ll get paid into this account for your ticket sales at the end
              of everyday.
            </p>
          </div>

          <InfoCard
            leftIcon="info"
            title="One more thing before your event goes live"
            text="You can always edit your payout account in Settings"
            className="md:!items-start"
          />

          <PayoutForm
            className="w-full"
            onSuccess={async () => {
              const resp = await updateEventStatus({
                id: id!,
                payload: { status: "upcoming" },
              });
              if (resp.data?.status === "success") {
                navigate(
                  `/events/${resp.data.data.slug}/published?eventName=${encodeURIComponent(resp.data.data.name)}`,
                  {
                    replace: true,
                  },
                );
              }
            }}
          >
            {({ handleSubmit, loading }) => {
              return (
                <>
                  <Button
                    type="button"
                    onClick={handleSubmit}
                    loading={loading || updatingEventStatus}
                    disabled={loading || updatingEventStatus}
                    text="Add Payout Account"
                    className="!max-w-full"
                  />

                  <button
                    type="button"
                    className="w-full text-center text-base font-bold text-grey-500"
                    onClick={() => {
                      handleModalOpen("confirmationModal");
                    }}
                  >
                    I'll do this later
                  </button>
                </>
              );
            }}
          </PayoutForm>
        </BgWrapper>
      </div>

      <ConfirmationModal
        open={modal === "confirmationModal" && modalOpen}
        handleClose={() => {
          handleModalClose();
        }}
        title="This will save your event as draft"
        subtitle="You need to add a payout account so we can publish your event. You can always edit your payout account anytime in Settings."
        onProceed={() => {
          toast.success("Saved as draft");
          navigate("/events?EventStatus=draft");
        }}
        loading={false}
        cancelText="Add Payout Account"
        proceedText="Save As Draft"
      />
    </div>
  );
};
